export default __webpack_public_path__ + "static/media/flowers-right.6ffb5f90.svg";